import React from 'react';
import PropTypes from 'prop-types';
import './TabBar.scss';

/**
 * TabBar Component
 *
 * A reusable tab navigation component with an underline indicator for the active tab.
 *
 * @component
 * @example
 * const tabs = [
 *   { label: 'All', value: 'all' },
 *   { label: 'Pending', value: 'pending' },
 *   { label: 'Accepted', value: 'accepted' }
 * ];
 *
 * <TabBar
 *   tabs={tabs}
 *   activeTab="pending"
 *   onTabChange={(value) => console.log(value)}
 * />
 */
export const TabBar = ({ tabs, activeTab, onTabChange, className = '' }) => {
  return (
    <div className={`tab-bar ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={`tab-bar__item ${
            activeTab === tab.value ? 'tab-bar__item--active' : ''
          }`}
          onClick={() => onTabChange(tab.value)}
          type='button'
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
